import type {
  ActivityReview,
  ReviewSummary,
  ReviewsRequest,
} from "@b2bportal/rbc-activities-api";
import { activitiesApi } from "@overrides/utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActivitiesShopActions } from "..";
import type { ActivitiesState } from "../../../../store";

export type FetchActivityReviewsFulfillResponse = {
  reviews: ActivityReview[];
  reviewSummary: ReviewSummary;
  search: ReviewsRequest;
};

export const fetchActivityReviews = createAsyncThunk<
  FetchActivityReviewsFulfillResponse,
  { search: ReviewsRequest },
  { state: ActivitiesState; rejectValue: { error: string } }
>("activitiesShop/fetchActivityReviews", async ({ search }, thunkAPI) => {
  try {
    const reviewsRes = await activitiesApi.apiV0ActivitiesReviewsPost(search);
    // TODO(Nate): Update type from activities-api to include value
    return {
      // @ts-expect-error
      reviews: reviewsRes.data?.value?.reviews,
      // @ts-expect-error
      reviewSummary: reviewsRes.data?.value?.summary,
      search,
    };
  } catch (error) {
    thunkAPI.dispatch(ActivitiesShopActions.setActivityUnavailable(true));
    return thunkAPI.rejectWithValue({ error: String(error) });
  }
});
